export default "__VITE_ASSET__DzPD7r4W__"